<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("cinema", 1) }} {{ $t("tickettemplates") }}
      </div>
      <div>
        <router-link class="btn-blue" to="cinema-ticket-templates"
          >{{ $t("tickettemplates") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <!-- <label
              :class="ticketDetails.temp_name && ticketDetails.temp_name.length > 0 ? 'shift-up' : '' "
            >{{ $t('template') }} {{ $t('name') }}</label> -->
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="ticketDetails.temp_name" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(template, templateIndex) in TemplateList"
                  @click="OnSelectTemplate(template)"
                  :key="templateIndex"
                >{{template.t_name}}</b-dropdown-item>
              </b-dropdown> -->
              <label :class="selected_ttemp ? 'shift-up' : ''"
                >{{ $t("template") }} {{ $t("name") }}</label
              >
              <custommultiselect
                :options="TemplateList"
                v-model="selected_ttemp"
                @select="OnSelectTemplate($event)"
                placeholder="Select Ticket Template"
                label="t_name"
                :multiple="false"
                track-by="t_id"
              ></custommultiselect>
              <Tooltip :title="$t('ticket_temp')" />
              <img
                v-if="selected_ttemp && TicketTempPreview"
                src="@/assets/img/icons/empty-image.svg"
                height="25"
                width="25"
                class="rounded ml-2"
                @click="onPreview('Ticket')"
                v-b-tooltip.hover
                :title="$t('preview')"
              />
            </div>
            <p class="error_message">
              <span v-if="submitted && ticketDetails.temp_name.length == 0"
                >Please select ticket template.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <!-- <label
              :class="ticketDetails.receipt_temp_name && ticketDetails.receipt_temp_name.length > 0 ? 'shift-up' : '' "
            >{{ $t('select') }} {{ $t('receipts') }} {{ $t('template') }}</label> -->
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown
                :text="ticketDetails.receipt_temp_name"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(rtemplate, rtemplateIndex) in ReceiptTemplateList"
                  @click="OnSelectReceiptTemplate(rtemplate)"
                  :key="rtemplateIndex"
                >{{rtemplate.rtemp_name}}</b-dropdown-item>
              </b-dropdown> -->
              <label :class="selected_rtemp ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $t("receipts") }}
                {{ $t("template") }}</label
              >
              <custommultiselect
                :options="ReceiptTemplateList"
                v-model="selected_rtemp"
                @select="OnSelectReceiptTemplate($event)"
                placeholder="Select Receipt Template"
                label="rtemp_name"
                :multiple="false"
                track-by="rtemp_id"
              ></custommultiselect>
              <Tooltip :title="``" />
              <img
                v-if="ticketDetails.receipt_temp_name && ReceiptTempPreview"
                src="@/assets/img/icons/empty-image.svg"
                height="25"
                width="25"
                class="rounded ml-2"
                @click="onPreview('Receipt')"
                v-b-tooltip.hover
                :title="$t('preview')"
              />
            </div>
            <p class="error_message">
              <span
                v-if="submitted && ticketDetails.receipt_temp_name.length == 0"
                >Please select receipt template.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <div class="d-flex justify-content-center align-items-center">
              <label :class="selected_etemp ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $t("email") }}
                {{ $t("template") }}</label
              >
              <custommultiselect
                :options="EmailTempList"
                v-model="selected_etemp"
                @select="onSelectTempNew($event, 'Email')"
                placeholder="Select Email Template"
                label="t_name"
                :multiple="false"
                track-by="t_id"
              ></custommultiselect>
              <Tooltip :title="$t('email_temp')" />
              <img
                v-if="selected_etemp && EmailTempPreview"
                src="@/assets/img/icons/empty-image.svg"
                height="25"
                width="25"
                class="rounded ml-2"
                @click="onPreview('Email')"
                v-b-tooltip.hover
                :title="$t('preview')"
              />
            </div>
            <p class="error_message">
              <!-- <span
                v-if="submitted && ticketDetails.email_temp_name.length == 0"
              >Please select Email template.</span> -->
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <div class="d-flex justify-content-center align-items-center">
              <label :class="selected_stemp ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $t("SMS") }} {{ $t("template") }}</label
              >
              <custommultiselect
                :options="SMSTempList"
                v-model="selected_stemp"
                @select="onSelectTempNew($event, 'SMS')"
                @remove="onRemoveTempNew($event, 'SMS')"
                placeholder="Select SMS Template"
                label="t_name"
                :multiple="false"
                track-by="t_id"
              ></custommultiselect>
              <Tooltip :title="$t('sms_temp')" />
              <img
                v-if="selected_stemp && SMSTempPreview"
                src="@/assets/img/icons/empty-image.svg"
                height="25"
                width="25"
                class="rounded ml-2"
                @click="onPreview('SMS')"
                v-b-tooltip.hover
                :title="$t('preview')"
              />
            </div>
            <p class="error_message">
              <!-- <span
                v-if="submitted && ticketDetails.sms_temp_name.length == 0"
              >Please select SMS template.</span> -->
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <div class="d-flex justify-content-center align-items-center">
              <label :class="selected_wtemp ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $t("WhatsApp") }}
                {{ $t("template") }}</label
              >
              <custommultiselect
                :options="WhatsAppTempList"
                v-model="selected_wtemp"
                @select="onSelectTempNew($event, 'WhatsApp')"
                @remove="onRemoveTempNew($event, 'WhatsApp')"
                placeholder="Select WhatsApp Template"
                label="t_name"
                :multiple="false"
                track-by="t_id"
              ></custommultiselect>
              <Tooltip :title="$t('whatsapp_temp')" />
              <img
                v-if="selected_wtemp && WhatsAppTempPreview"
                src="@/assets/img/icons/empty-image.svg"
                height="25"
                width="25"
                class="rounded ml-2"
                @click="onPreview('WhatsApp')"
                v-b-tooltip.hover
                :title="$t('preview')"
              />
            </div>
            <p class="error_message">
              <!-- <span
                v-if="submitted && ticketDetails.whatsApp_temp_name.length == 0"
              >Please select WhatsApp template.</span> -->
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4" v-if="false">
          <div class="dropdown-curve-container">
            <div class="d-flex justify-content-center align-items-center">
              <label :class="selected_refundtemp ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $t("Refund") }}
                {{ $t("template") }}</label
              >
              <custommultiselect
                :options="RefundTempList"
                v-model="selected_refundtemp"
                @select="onSelectTempNew($event, 'Refund')"
                @remove="onRemoveTempNew($event, 'Refund')"
                placeholder="Select Refund Template"
                label="t_name"
                :multiple="false"
                track-by="t_id"
              ></custommultiselect>
              <Tooltip :title="$t('Refund Template')" />
              <img
                v-if="selected_refundtemp && RefundTempPreview"
                src="@/assets/img/icons/empty-image.svg"
                height="25"
                width="25"
                class="rounded ml-2"
                @click="onPreview('Refund')"
                v-b-tooltip.hover
                :title="$t('preview')"
              />
            </div>
            <p class="error_message">
              <!-- <span
                v-if="submitted && ticketDetails.whatsApp_temp_name.length == 0"
              >Please select WhatsApp template.</span> -->
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="cinema_name.length > 0 ? 'shift-up' : ''"
              >Select Cinema</label
            >
            <div class="d-flex justify-content-center align-items-center">
              <!-- <b-dropdown :text="cinema_name" variant="dropdown-curve" class="w-100">
                <b-dropdown-item
                  v-for="(cinema, cinemaIndex) in cinemaList"
                  @click="OnSelectCinema(cinema)"
                  :key="cinemaIndex"
                >{{cinema.cine_name}}</b-dropdown-item>
              </b-dropdown> -->
              <custommultiselect
                :options="cinemaList"
                v-model="selected_cinema"
                placeholder="Select Cinemas"
                @select="OnSelectCinema($event)"
                label="cine_name"
                :multiple="false"
                :disabled="isRoleID"
                track-by="cine_id"
              ></custommultiselect>
              <Tooltip :title="``" />
            </div>
            <p class="error_message">
              <span v-if="submitted && ticketDetails.temp_cinema_id.length == 0"
                >Please select cinema.</span
              >
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="dropdown-curve-container">
            <label :class="copies_name.length > 0 ? 'shift-up' : ''">{{
              $t("copies")
            }}</label>
            <div class="d-flex justify-content-center align-items-center">
              <b-dropdown
                :text="copies_name"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(copy, copyIndex) in copies"
                  @click="OnSelectCopies(copy)"
                  :key="copyIndex"
                  >{{ copy.name }}</b-dropdown-item
                >
              </b-dropdown>
              <Tooltip :title="``" />
            </div>
            <p class="error_message">
              <span></span>
            </p>
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="label_1"
                name="label_1"
                v-validate=""
                v-model="ticketDetails.label_1"
                placeholder="."
              />
              <label>Label 1</label>
            </div>
            <Tooltip :title="$t('label_1')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('label_1')">{{
              errors.first("label_1")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="label_2"
                name="label_2"
                v-validate=""
                v-model="ticketDetails.label_2"
                placeholder="."
              />
              <label>Label 2</label>
            </div>
            <Tooltip :title="$t('label_2')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('label_2')">{{
              errors.first("label_2")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <input
                id="label_top_1"
                name="label_top_1"
                v-model="ticketDetails.label_top_1"
                placeholder="."
              />
              <label>Label Top 1</label>
            </div>
            <Tooltip :title="$t('label_top_1')" />
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-3 col-xl-2">
              <label>{{ $t("active") }}</label>
            </div>
            <div class="col-md-9 col-xl-10">
              <div class="col-4">
                <b-form-checkbox
                  disabled
                  switch
                  v-model="ticketDetails.temp_active"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0"
                >{{ $t("single") }} {{ $tc("seat", 1) }}
                {{ $tc("ticket", 1) }}</label
              >
            </div>
            <div class="col-md-6 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_single_Ticket"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-md-12">
          <div class="section-title mb-3">
            {{ $tc("ticket", 1) }} {{ $t("content") }}
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0"
                >{{ $t("show") }} {{ $tc("cinema", 1) }} {{ $t("name") }}</label
              >
            </div>
            <div class="col-md-6 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_cinema_name"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $t("contactno") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_contact_number"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $t("show") }} {{ $t("address") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_show_address"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $t("support") }} {{ $t("email") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_email"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0"
                >{{ $tc("screen", 1) }} {{ $t("name") }}</label
              >
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_screen_name"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $tc("seat", 1) }} {{ $t("type") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_seat_type"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $tc("seat", 1) }} {{ $t("name") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_seat_name"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0"
                >{{ $t("tax") }} / {{ $tc("charge", 1) }}
                {{ $tc("details", 2) }}</label
              >
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_tax_details"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <!-- <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $t('separate') }} {{ $tc('fb') }} {{ $t('bill') }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_fnb_bill"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>-->

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $t("datetime") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_datetime"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">QR {{ $t("code") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_qrcode"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="row">
            <div class="col-md-6">
              <label class="mb-0">{{ $t("specialinstruction") }}</label>
            </div>
            <div class="col-md-5 d-flex align-items-center">
              <div class>
                <b-form-checkbox
                  switch
                  v-model="ticketDetails.temp_special_instruction"
                  value="Y"
                  unchecked-value="N"
                  name="check-button"
                ></b-form-checkbox>
              </div>
            </div>
          </div>
          <p class="error_message">
            <span></span>
          </p>

          <div v-if="ticketDetails.temp_special_instruction == 'Y'">
            <div class="d-flex align-items-center">
              <div class="input-material w-62">
                <input
                  v-model="ticketDetails.temp_special_text"
                  name="special_text"
                  id="special_text"
                  v-validate="'required'"
                  placeholder="."
                  type="text"
                />
              </div>
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has('special_text')">{{
                errors.first("special_text")
              }}</span>
            </p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="OnFinalSubmit()"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>
          <!-- <button
            @click.prevent.stop="OnFinalSubmit(false)"
            class="btn-blue"
          >{{ $t('saveaddmore') }}</button>-->
          <!-- <button @click.prevent.stop="OnReset()" class="btn-black">{{ $t('reset') }}</button> -->
          <b-button
            class="btn-outline-grey"
            variant="default"
            to="cinema-ticket-templates"
            >{{ $t("cancel") }}</b-button
          >
        </div>
        <b-modal
          ref="preview-modal"
          id="selected-template-preview-modal"
          size="lg"
          :title="'Preview'"
          hide-footer
        >
          <div class="TempPreview">
            <div
              v-if="selectedType == 'Ticket'"
              v-html="TicketTempPreview"
            ></div>
            <div v-if="selectedType == 'SMS'" v-html="SMSTempPreview"></div>
            <div v-if="selectedType == 'Email'" v-html="EmailTempPreview"></div>
            <div
              v-if="selectedType == 'WhatsApp'"
              v-html="WhatsAppTempPreview"
            ></div>
            <div
              v-if="selectedType == 'Receipt'"
              v-html="ReceiptTempPreview"
            ></div>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CinemasService from "@/services/CinemasService";

export default {
  data() {
    return {
      btenable: false,
      cinemaList: [],
      submitted: false,
      cinema_name: "",
      copies_name: "",
      ticketDetails: {
        temp_tt_id: "",
        temp_id: null,
        temp_name: "",
        receipt_temp_id: null,
        receipt_temp_name: "",
        temp_cinema_id: [],
        temp_no_of_copies_id: "",
        temp_active: "Y",
        temp_single_Ticket: "Y",
        temp_cinema_name: "Y",
        temp_contact_number: "N",
        temp_show_address: "Y",
        temp_email: "N",
        temp_screen_name: "Y",
        temp_seat_type: "Y",
        temp_seat_name: "Y",
        temp_tax_details: "N",
        temp_fnb_bill: "N",
        temp_special_instruction: "N",
        temp_special_text: "",
        temp_datetime: "Y",
        temp_qrcode: "N",
        sms_temp_id: null,
        sms_temp_name: "",
        email_temp_id: null,
        email_temp_name: "",
        whatsApp_temp_id: null,
        whatsApp_temp_name: "",
        refund_temp_id: null,
        refund_temp_name: "",
        label_1: "",
        label_2: "",
        label_top_1: ""
      },
      copies: [],
      TemplateList: [],
      ReceiptTemplateList: [],
      selected_ttemp: "",
      selected_rtemp: "",
      selected_etemp: "",
      selected_stemp: "",
      selected_wtemp: "",
      selected_refundtemp: "",
      selected_cinema: "",
      SMSTempList: [],
      EmailTempList: [],
      WhatsAppTempList: [],
      RefundTempList: [],
      errmsg: "",
      previewData: "",
      ModalTitle: "",
      selectedType: "",
      TicketTempPreview: "",
      SMSTempPreview: "",
      WhatsAppTempPreview: "",
      EmailTempPreview: "",
      ReceiptTempPreview: "",
      errmsg: "",
      RefundTempPreview: "",
    };
  },
   computed: {
    CLIENT_SETUP_NAME() {
      console.log("CLIENT_SETUP_NAME", this.$store.getters.CLIENT_SETUP_NAME)
      return this.$store.getters.CLIENT_SETUP_NAME;
    },
  },
  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    this.cinema_manager_add_edit_disabled = roleid;
    if (true) {
      this.isRoleID = false;
    }
    this.getCinemaList(obj);
    const { tt_id } = this.$route.query;
    this.ticketDetails.temp_tt_id = tt_id;

    this.noofcopies();

    this.GetTicektTemplateDetails(tt_id);
    this.getReceiptTemplateList();
    this.getTicketTemplate();

    this.ticketDetails.temp_no_of_copies_id = 1;
    this.copies_name = "1";

    // this.getCinemaList();
  },

  methods: {
    noofcopies: function() {
      this.copies = [
        { name: 1 },
        { name: 2 },
        { name: 3 },
        { name: 4 },
        { name: 5 },
        { name: 6 },
        { name: 7 },
        { name: 8 },
        { name: 9 },
        { name: 10 }
      ];
    },

    OnReset: function() {
      this.ticketDetails = {
        temp_id: null,
        temp_name: "",
        temp_cinema_id: [],
        temp_no_of_copies_id: 1,
        temp_active: "Y",
        temp_single_Ticket: "Y",
        temp_cinema_name: "Y",
        temp_contact_number: "N",
        temp_show_address: "Y",
        temp_email: "N",
        temp_screen_name: "Y",
        temp_seat_type: "Y",
        temp_seat_name: "Y",
        temp_tax_details: "N",
        temp_fnb_bill: "N",
        temp_special_instruction: "N",
        temp_special_text: "",
        temp_datetime: "Y",
        temp_qrcode: "N",
        label_1: "",
        label_2: ""
      };
      this.cinema_name = "";
      this.copies_name = "1";
      this.TicketTempPreview = "";
      this.SMSTempPreview = "";
      this.WhatsAppTempPreview = "";
      this.EmailTempPreview = "";
      this.ReceiptTempPreview = "";
    },
    onPreview(type) {
      this.selectedType = type;
      this.$refs["preview-modal"].show();
    },
    getReceiptTemplateList: function(id) {
      let body = {
        limit: null,
        currentPage: null
      };
      MasterService.GetReceiptTemplate(body).then(response => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            this.ReceiptTemplateList = data.Records;

            this.ReceiptTemplateList.map(x => {
              if (String(id) == String(x.rtemp_id)) {
                this.ticketDetails.receipt_temp_name = x.rtemp_name;
                this.ticketDetails.receipt_temp_id = x.rtemp_id;
                this.GetReceiptTemplateDetails(x.rtemp_id);
                this.selected_rtemp = x;
              }
            });
          }
        }
      });
    },
    getTicketTemplate: function(
      id,
      sms_temp_id,
      email_temp_id,
      whatsApp_temp_id,
      refund_temp_id,
    ) {
      let body = {
        limit: null,
        currentPage: null
      };

      MasterService.GetTicketTemplate(body).then(response => {
        const { data } = response;
        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            // this.TemplateList = data.Records;
          data.Records = data.Records.filter((x) => String(x.project_name).toLowerCase() == String(this.CLIENT_SETUP_NAME.toLowerCase()) || !x.project_name)

            this.TemplateList = data.Records.filter(x => x.type == "Ticket");
            this.SMSTempList = data.Records.filter(x => x.type == "SMS");
            this.EmailTempList = data.Records.filter(x => x.type == "Email");
            this.RefundTempList = data.Records.filter(x => x.type == "Refund");
            this.WhatsAppTempList = data.Records.filter(
              x => x.type == "WhatsApp"
            );

            this.SMSTempList.map(x => {
              if (String(sms_temp_id) == String(x.t_id)) {
                this.ticketDetails.sms_temp_name = x.t_name;
                this.ticketDetails.sms_temp_id = x.t_id;
                this.GetTicektTemplatePreview(x.t_id, "SMS");
                this.selected_stemp = x;
              }
            });

            this.EmailTempList.map(x => {
              if (String(email_temp_id) == String(x.t_id)) {
                this.ticketDetails.email_temp_name = x.t_name;
                this.ticketDetails.email_temp_id = x.t_id;
                this.GetTicektTemplatePreview(x.t_id, "Email");
                this.selected_etemp = x;
              }
            });

            this.WhatsAppTempList.map(x => {
              if (String(whatsApp_temp_id) == String(x.t_id)) {
                this.ticketDetails.whatsApp_temp_name = x.t_name;
                this.ticketDetails.whatsApp_temp_id = x.t_id;
                this.GetTicektTemplatePreview(x.t_id, "WhatsApp");
                this.selected_wtemp = x;
              }
            });

            this.RefundTempList.map(x => {
              if (String(refund_temp_id) == String(x.t_id)) {
                this.ticketDetails.refund_temp_name = x.t_name;
                this.ticketDetails.refund_temp_id = x.t_id;
                this.GetTicektTemplatePreview(x.t_id, "Refund");
                this.selected_refundtemp = x;
              }
            });

            this.TemplateList.map(x => {
              if (String(id) == String(x.t_id)) {
                this.ticketDetails.temp_name = x.t_name;
                this.ticketDetails.temp_id = x.t_id;
                this.GetTicektTemplatePreview(x.t_id, "Ticket");
                this.selected_ttemp = x;
              }
            });
          }
        } else {
          this.$toasted.show(data.message);
        }
      });
    },
    GetTicektTemplatePreview: function(id, type) {
      let body = {
        temp_id: id,
        flag: "View"
      };

      MasterService.GetTicketTemplate(body).then(response => {
        console.log("response :", response);
        if (type == "Ticket") {
          this.TicketTempPreview = response.data;
        } else if (type == "Email") {
          this.EmailTempPreview = response.data;
        } else if (type == "SMS") {
          this.SMSTempPreview = response.data;
        } else if (type == "WhatsApp") {
          this.WhatsAppTempPreview = response.data;
        } else if (type == "Refund") {
          this.RefundTempPreview = response.data;
        }
      });
    },

    GetTicektTemplateDetails: function(id) {
      let body = {
        temp_id: id
      };
      MasterService.GetCinemaTicketTemplate(body).then(response => {
        const { data } = response;

        if (data.status) {
          if (data.Records && data.Records.length > 0) {
            let obj = data.Records[0];

            this.getTicketTemplate(
              obj.template_id,
              obj.sms_temp_id,
              obj.email_temp_id,
              obj.whatsapp_temp_id,
              obj.refund_temp_id,
            );
            this.getReceiptTemplateList(obj.receipt_temp_id);
            this.setCinema(obj.cinema_id);
            this.ticketDetails.temp_no_of_copies_id = obj.tt_no_of_copy;
            this.copies_name = String(obj.tt_no_of_copy);
            this.ticketDetails.temp_active = obj.tt_is_active;
            this.ticketDetails.temp_single_Ticket = obj.tt_single_seat_ticket;
            this.ticketDetails.temp_cinema_name = obj.tt_show_cinema_name;
            this.ticketDetails.temp_contact_number = obj.tt_show_contact_no;
            this.ticketDetails.temp_show_address = obj.tt_show_address;
            this.ticketDetails.temp_email = obj.tt_show_support_email;
            this.ticketDetails.temp_screen_name = obj.tt_show_screen_name;
            this.ticketDetails.temp_seat_type = obj.tt_show_seat_type;
            this.ticketDetails.temp_seat_name = obj.tt_show_seat_name;
            this.ticketDetails.temp_tax_details = obj.tt_show_charge_details;
            this.ticketDetails.temp_fnb_bill = obj.tt_fnb_separate_ticket;
            this.ticketDetails.temp_special_instruction =
              obj.tt_show_instruction;
            this.ticketDetails.temp_special_text = obj.tt_instruction;
            this.ticketDetails.temp_datetime = obj.tt_show_date_time;
            this.ticketDetails.temp_qrcode = obj.tt_show_qr_code;
            this.ticketDetails.label_1 = obj.label_1;
            this.ticketDetails.label_2 = obj.label_2;
            this.ticketDetails.label_top_1 = obj.label_top_1;
          }
        }
      });
    },
    setCinema: function(cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            // this.cinemaList = data.Records;
            if (cine_id === undefined) {
            } else {
              this.cinemaList.map(x => {
                if (String(cine_id) === String(x.cine_id)) {
                  this.cinema_name = x.cine_name;
                  this.ticketDetails.temp_cinema_id = x.cine_id;
                  this.selected_cinema = x;
                }
              });
            }
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch On GetInActiveCinemas :", error);
        });
    },
    getCinemaList: function(cine_id) {
      MasterService.GetCinemas({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinemaList = data.Records;
            // if (cine_id === undefined) {
            // } else {
            //   this.cinemaList.map(x => {
            //     if (String(cine_id) === String(x.cine_id)) {
            //       this.cinema_name = x.cine_name;
            //       this.ticketDetails.temp_cinema_id = x.cine_id;
            //     }
            //   });
            // }
          } else {
            // Show Error Message:
            console.log("data.message :", data.message);
          }
        })
        .catch(error => {
          // Catch Error:
          console.log("Catch On GetInActiveCinemas :", error);
        });
    },

    OnSelectCopies: function(copy) {
      this.ticketDetails.temp_no_of_copies_id = copy.name;
      this.copies_name = String(copy.name);
    },

    OnSelectCinema: function(cinema) {
      this.ticketDetails.temp_cinema_id = cinema.cine_id;
      this.cinema_name = cinema.cine_name;
    },

    onSelectTempNew(template, type) {
      if (type == "Email") {
        this.EmailTempPreview = "";
        this.ticketDetails.email_temp_name = template.t_name;
        this.ticketDetails.email_temp_id = template.t_id;
        this.GetTicektTemplatePreview(template.t_id, "Email");
      } else if (type == "SMS") {
        this.SMSTempPreview = "";
        this.ticketDetails.sms_temp_name = template.t_name;
        this.ticketDetails.sms_temp_id = template.t_id;
        this.GetTicektTemplatePreview(template.t_id, "SMS");
      } else if (type == "WhatsApp") {
        this.WhatsAppTempPreview = "";
        this.ticketDetails.whatsApp_temp_name = template.t_name;
        this.ticketDetails.whatsApp_temp_id = template.t_id;
        this.GetTicektTemplatePreview(template.t_id, "WhatsApp");
      } else if (type == "Ticket") {
        this.TicketTempPreview = "";
        this.ticketDetails.temp_name = template.t_name;
        this.ticketDetails.temp_id = template.t_id;
        this.GetTicektTemplatePreview(template.t_id, "Ticket");
      } else if (type == "Refund") {
        this.RefundTempPreview = "";
        this.ticketDetails.refund_temp_name = template.t_name;
        this.ticketDetails.refund_temp_id = template.t_id;
        this.GetTicektTemplatePreview(template.t_id, "Refund");
      }
    },

     onRemoveTempNew(template, type) {
      if (type == "Email") {
        this.EmailTempPreview = "";
        this.ticketDetails.email_temp_name = "";
        this.ticketDetails.email_temp_id = null;
      } else if (type == "SMS") {
        this.SMSTempPreview = "";
        this.ticketDetails.sms_temp_name = '';
        this.ticketDetails.sms_temp_id = null;
      } else if (type == "WhatsApp") {
        this.WhatsAppTempPreview = "";
        this.ticketDetails.whatsApp_temp_name = "";
        this.ticketDetails.whatsApp_temp_id = null;
      } else if (type == "Ticket") {
        this.TicketTempPreview = "";
        this.ticketDetails.temp_name = "";
        this.ticketDetails.temp_id = null;
      } else if (type == "Refund") {
        this.RefundTempPreview = "";
        this.ticketDetails.refund_temp_name = "";
        this.ticketDetails.refund_temp_id = null;
      }
    },

    OnSelectTemplate: function(template) {
      this.TicketTempPreview = "";
      this.ticketDetails.temp_name = template.t_name;
      this.ticketDetails.temp_id = template.t_id;
      this.GetTicektTemplatePreview(template.t_id, "Ticket");
    },

    OnSelectReceiptTemplate: function(template) {
      this.ticketDetails.receipt_temp_name = template.rtemp_name;
      this.ticketDetails.receipt_temp_id = template.rtemp_id;
      this.ReceiptTempPreview = "";
      this.GetReceiptTemplateDetails(template.rtemp_id);
    },

    GetReceiptTemplateDetails: function(id) {
      let payload = {
        rtemp_id: id,
        flag: "View"
      };

      MasterService.GetSingleReceiptTemplate(payload)
        .then(response => {
          const { data } = response;
          this.ReceiptTempPreview = data;
        })
        .catch(this._CatchError);
    },

    OnFinalSubmit: function() {
      this.submitted = true;

      this.$validator.validate().then(valid => {
        if (this.ticketDetails.temp_cinema_id.length == 0) {
          return;
        }
        if (this.ticketDetails.temp_name.length == 0) {
          return;
        }
        if (this.ticketDetails.receipt_temp_name.length == 0) {
          return;
        }
        if (valid) {
          this.btenable = true;
          // console.log("this.ticketDetails :", this.ticketDetails);
          MasterService.EditCinemaTicketTemplate(this.ticketDetails)
            .then(response => {
              this.btenable = false;
              console.log("response :", response);
              const { data } = response;

              if (data.status) {
                this.OnReset();
                this.$toasted.show(data.message);
                this.$router.push({
                  path: "/master/cinema-ticket-templates"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    }
  }
};
</script>

<style>
.w-62 {
  width: 62%;
}

.TempPreview table {
  border-collapse: unset !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CinemaTicketTemplates/editCinemaTicketTemplates.vue